import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

export function ModalMessage({ dataObject, setOpen }) {
  const handleClose = () => {
    setOpen(null); // Cerramos el modal estableciendo el estado a null
  };

  // Filtramos el objeto para omitir la clave "Clase"
  const filteredDataObject = Object.fromEntries(
    Object.entries(dataObject).filter(([key, value]) => key !== 'Clase')
  );

  return (
    <Dialog
      open={Boolean(dataObject)}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <DialogTitle id="child-modal-title">{dataObject.Clase}</DialogTitle>
      <DialogContent>
        {/* Renderizamos cada campo y valor del objeto dataObject sin la clave "Clase" */}
        {Object.entries(filteredDataObject).map(([key, value]) => (
          <DialogContentText key={key} id="child-modal-description">
            <strong>{key}:</strong> {value}
          </DialogContentText>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}